// Lives in its own file (like DateTimeDisplayStyle.ts) so callers such as FormattedDateTime.tsx
// can use it without importing DateTimeDisplay.tsx, which pulls in Semantic UI's Grid.
export enum MomentConfig {
    ShowOnlyDate,
    ShowDateWithMoment,
    ShowMomentOnly
}
